import { parseDocumentFromString, serializeDocument } from 'anodum';
import template from '../../template';
import actionTypes from '../constants/action-types';
import selectors from '../selectors';
import verifiers from '../verifiers';
import operations from '../operations';
import createPage from '../actions/create-page';
import setActivePage from '../actions/set-active-page';
import setPageHTML from '../actions/set-page-html';
import updatePageSettings from '../actions/update-page-settings';
import setHtmlCheckpoint from '../actions/set-html-checkpoint';
import replaceTitleInHtml from '../helpers/replace-title-in-html';
import getCurrentLocale from '../../site-locales/selectors/current-locale';
import isFunction from '../../../utils/is-function';

const pageCreator = (store) => (next) => async (action) => {
  switch (action.type) {
    case actionTypes.CREATE_PAGE_FROM_TEMPLATE: {
      const {
        pageModifier,
        pageTemplateId,
        title,
        displayInNavigation,
        skipActivePageChange,
        displayBusinessName,
      } = action.payload;
      const state = store.getState();

      const pageTemplate = template.selectors.getPageTemplate(state, pageTemplateId);

      if (!pageTemplate) {
        next(action);
        break;
      }

      const { html, usedBlocks } = pageTemplate;
      const targetHTML = replaceTitleInHtml(html, title);
      const targetDocument = parseDocumentFromString(targetHTML);

      if (isFunction(pageModifier)) pageModifier(targetDocument);

      const activeLocale = getCurrentLocale(state);

      store.dispatch(
        createPage({
          html: serializeDocument(targetDocument),
          locale: activeLocale,
          displayInNavigation,
          usedBlocks,
          pageTemplateId,
          isMultilingualSite: verifiers.isMultilingualSite(),
          name: title,
          skipActivePageChange,
          displayBusinessName,
        })
      );
      next(action);

      break;
    }

    case actionTypes.COPY_PAGE:
    case actionTypes.CREATE_PAGE: {
      next(action);

      if (action.payload.skipActivePageChange) {
        break;
      }

      const state = store.getState();
      const newPage = selectors.getPage(state, action.payload.pageId);
      store.dispatch(setActivePage(newPage.id));

      break;
    }

    case actionTypes.TRANSLATE_PAGE: {
      const {
        pageId,
        options: { pageIdToOverride },
      } = action.payload;

      let overridedPage;

      if (pageIdToOverride) {
        const prevState = store.getState();
        overridedPage = selectors.getPage(prevState, pageIdToOverride);
      }

      next(action);

      const state = store.getState();
      const newPageId = pageIdToOverride || pageId;
      const newPage = selectors.getPage(state, newPageId);

      store.dispatch(setPageHTML(newPage.id, newPage.html));
      store.dispatch(setHtmlCheckpoint(newPage.id, newPage.html));
      await operations.setActivePage(newPage.id);

      if (pageIdToOverride) {
        store.dispatch(
          updatePageSettings(newPage.id, newPage, {
            forceNagivationUpdate: true,
            overridedPage,
          })
        );
      } else {
        const isDisplayInNavAvailable = template.verifiers.isVariableGlobalsAvailable('navigation');
        store.dispatch(
          updatePageSettings(newPage.id, {
            ...newPage,
            displayInNavigation: isDisplayInNavAvailable,
          })
        );
      }

      break;
    }

    default:
      next(action);
  }
};

export default pageCreator;
